module.exports = __webpack_public_path__ + "static/img/led_difuso_branco_3mm-1.ac58ab0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/led_difuso_branco_3mm-1.svg
// module id = 9cTr
// module chunks = 0